import { PageBackground, PageShell, Form, ProductListCard } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import CartHeader from "./components/CartHeader";
import EmptyCartState from "./components/EmptyCartState";
import CartProductItem from "./components/CartProductItem";
import DeleteProductModal from "./components/DeleteProductModal";
import CartSummaryActions from "./components/CartSummaryActions";
import { toast } from "react-toastify";
import { ICartProduct, IStore, ISale } from "../../classes/interfaces";
import { postSale, buildSaleProducts } from "../../services/saleService";
import { formatBRL } from "../../helpers/currency.helper";
import { useCart } from "../../hooks/useCart";
import { setCartLineAmount } from "../../utils/cartCalculations";
import { getCartChannel } from "../../services/cartService";

export default function Cart() {
  //const history = useHistory();
  //let match = useRouteMatch();
  const navigate = useNavigate();
  const { suffix, tableId } = useParams<{ suffix: string; tableId: string }>();
  const { cart, setCart, clearCart } = useCart();
  const [state, setState] = React.useState({ status: "create" });

  const [deleteDialog, setDeleteDialog] = React.useState({
    isOpen: false,
    index: -1,
  });

  const store: IStore = JSON.parse(
    sessionStorage.getItem("@menuchef/store") || "{}"
  );

  // Preserva o contexto de origem: quem entrou pelo cardápio-vitrine (/menu)
  // deve voltar para /menu ao "adicionar mais itens", não cair na loja (/store).
  const isMenuChannel = cart ? getCartChannel(cart) === "menu" : false;
  const backToMenu = isMenuChannel ? `/menu/${suffix}` : `/store/${suffix}`;

  function openDeleteProduct(index: number) {
    setDeleteDialog({ isOpen: true, index: index });
  }
  function closeDeleteProduct() {
    setDeleteDialog({ isOpen: false, index: -1 });
  }

  /*const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    details: {
      display: "block",
    },
    checked: {
      color: teal[400],
      "&$checked": {
        color: teal[600],
      },
      margin: 0,
      marginLeft: 10,
      padding: 0,
    },
  }));

  const classes = useStyles();*/

  if (
    cart === undefined ||
    cart.products === undefined ||
    cart.products.length <= 0
  ) {
    return (
      <EmptyCartState
        onClearCart={() => {
          clearCart();
          setState({ status: "cart clear" });
        }}
        onAddItems={() => navigate(backToMenu)}
      />
    );
  }

  return (
    <>
      <PageBackground>
        <PageShell>
          <DeleteProductModal
            isOpen={deleteDialog.isOpen}
            onClose={closeDeleteProduct}
            onConfirm={() => {
              if (deleteDialog.index !== -1) {
                cart.products.splice(deleteDialog.index, 1);
              }

              let total = 0;
              cart.products.forEach((product: ICartProduct) => {
                total += product.total;
              });
              cart.total = total;
              if (cart.total <= 0) {
                cart.grouping_last = 0;
                cart.product_last = 0;
              }

              setCart(cart);
              closeDeleteProduct();
              setState({ status: "remove product" });
            }}
          />

          <Form
            onSubmit={(ev) => {
              ev.preventDefault();
            }}
          >
            <CartHeader
              count={cart.products.length}
              onClearCart={() => {
                clearCart();
                setState({ status: "cart clear" });
              }}
            />

            <ProductListCard>
              {cart.products.map((product: ICartProduct) => (
                <CartProductItem
                  key={product.id}
                  product={product}
                  onRemove={(p) => {
                    const index = cart.products.indexOf(p);
                    openDeleteProduct(index);
                  }}
                  onChangeAmount={(p, newAmount) => {
                    if (newAmount < 1) return; // remoção só pela lixeira + modal de confirmação
                    setCartLineAmount(cart, p, newAmount);
                    setCart({ ...cart });
                  }}
                />
              ))}
            </ProductListCard>

            <CartSummaryActions
              cartTotal={cart.total}
              isMenuStyle={isMenuChannel}
              isSending={state.status === "enviando"}
              onAddMoreItems={() => navigate(backToMenu)}
              onFinalizeOrder={() => {
                if (tableId) {
                  const sale: ISale = {
                    store: {
                      id: store.id,
                    },
                    document: Number(tableId),
                    tax: 0,
                    taxPayerIdentificationNumber: "",
                    deliveryName: "",
                    deliveryType: "table",
                    deliveryAddress: "",
                    deliveryNumber: "",
                    deliveryDistrict: "",
                    deliveryComplement: "",
                    deliveryReference: "",
                    deliveryZipCode: "",
                    phone: "",
                    note: "",
                    products: [],
                    payments: [],
                    voucherType: null,
                    voucherValue: null,
                  };

                  sale.products = buildSaleProducts(cart.products);

                  // validate
                  if (sale.products.length <= 0) {
                    toast("Nenhum produto encontrado no carrinho.", {
                      type: "error",
                      autoClose: 2000,
                    });
                    return;
                  }

                  setState({ status: "enviando" });
                  postSale(sale)
                    .then((data) => {
                      if (data === undefined || data.code === undefined) {
                        toast("Erro inesperado. Tente novamente mais tarde!", {
                          type: "error",
                          autoClose: 2000,
                        });
                        return;
                      }
                      if (data.code !== 200) {
                        if (data.status === "store closed") {
                          toast("Desculpe, a loja está fechada no momento.", {
                            type: "error",
                            autoClose: 2000,
                          });
                        }
                        return;
                      }
                      clearCart();
                      toast(
                        "Seu pedido está com o estabelecimento, em instantes será produzido.",
                        {
                          type: "success",
                          autoClose: 2000,
                          onClose: () => {
                            if (tableId && tableId !== "") {
                              navigate(`/store/${suffix}/table/${tableId}`);
                            } else {
                              navigate(`/store/${suffix}`);
                            }
                          },
                        }
                      );
                    })
                    .catch((error) => {
                      console.log(error.response);
                      toast("Erro no servidor. Tente novamente mais tarde!", {
                        type: "error",
                        autoClose: 2000,
                      });
                    });
                } else {
                  if (
                    store.minimumSaleValue !== null &&
                    store.minimumSaleValue > 0
                  ) {
                    if (cart.total < store.minimumSaleValue) {
                      toast(
                        `Não aceitamos pedidos abaixo de ${formatBRL(
                          store.minimumSaleValue
                        )}`,
                        {
                          type: "warning",
                          autoClose: 2000,
                        }
                      );
                      return;
                    }
                  }

                  navigate(`/store/${suffix}/payments`);
                }
              }}
            />
          </Form>
        </PageShell>
      </PageBackground>
    </>
  );
}
